import React from "react";

import {
  Icon,
  SmallText,
  TargetItem,
  TargetList,
  Text,
} from "./styles"

type TTargetBlock = {
  icon_svg: string;
  iconWidth?: number;
  text: string;
  smallText: string;
};

type TTargetSection = {
  data: TTargetBlock[];
};

export const TargetAudienceSection: React.FC<TTargetSection> = ({ data }) => {
  return (
    <TargetList>
      {data.map((item, index) => (
        <TargetItem key={index}>
          <Icon
            icon={item.icon_svg}
            $iconWidth={item.iconWidth}
          />
          <Text>{item.text}</Text>
          <SmallText>{item.smallText}</SmallText>
        </TargetItem>
      ))}
    </TargetList>
  )
}
